module.exports = __webpack_public_path__ + "img/notification-bell-desktop-en.e24ccd6e.jpg";